var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickmarkstep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8945 0.25C16.1314 0.253614 16.3533 0.359562 16.5117 0.536133C16.6692 0.7119 16.753 0.944343 16.75 1.18164C16.7473 1.38943 16.6779 1.59181 16.5518 1.75391L16.4941 1.82129L6.34375 12.4854L6.34277 12.4863C6.18241 12.6538 5.96388 12.7499 5.73242 12.749H5.73145L5.73047 12.75V12.749C5.49913 12.7497 5.28039 12.6537 5.12012 12.4863V12.4854L0.505859 7.63379V7.63281C0.425358 7.54796 0.361839 7.44806 0.318359 7.33887C0.274864 7.22948 0.251556 7.11213 0.25 6.99414C0.248465 6.87608 0.267987 6.75805 0.308594 6.64746C0.349177 6.53696 0.410058 6.43488 0.488281 6.34766C0.566637 6.26034 0.661638 6.1891 0.767578 6.13965C0.873545 6.09021 0.988667 6.06428 1.10547 6.0625C1.22225 6.06075 1.33796 6.08361 1.44531 6.12988C1.55249 6.17611 1.64884 6.24419 1.72949 6.3291L5.73145 10.5371L15.2705 0.516602C15.4338 0.344892 15.6579 0.246452 15.8945 0.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickmarkstep5);
export default __webpack_public_path__ + "static/media/tickmarkstep5.326c704486db2e95dacf8845f63c4b06.svg";
export { ForwardRef as ReactComponent };